export const TABS = {
  manual: "manual",
  import: "import",
};
